import { render, staticRenderFns } from "./elCheckBoxTree.vue?vue&type=template&id=6f52a63c&"
import script from "./elCheckBoxTree.vue?vue&type=script&lang=js&"
export * from "./elCheckBoxTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports